import {
  Box,
  Button,
  CircularProgress,
  Tab,
  Tabs,
  Typography,
} from '@mui/material'
import SubscriptionsPlan from './SubscriptionPlan'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  createSubscriptionAsync,
  fetchSubscriptionsAsync,
  makeSubscriptionPaymentAsync,
} from '../../services/paymentService'
import { RootState } from '../../store'
import {
  setIsPaymentProcessing,
  setSubscriptionsLoadingInProgress,
} from '../../actions/payment'

const Subscriptions = () => {
  const dispatch = useDispatch<any>()
  useEffect(() => {
    dispatch(setSubscriptionsLoadingInProgress(true))
    dispatch(fetchSubscriptionsAsync())
  }, [dispatch])

  const organization = useSelector(
    (state: RootState) => state.organization.selectedOrganization,
  )
  const subscriptions = useSelector(
    (state: RootState) => state.payment.subscriptions,
  )
  const currentSubscriptionPlan = useSelector(
    (state: RootState) => state.payment.currentSubscriptionPlan,
  )
  const isSubscriptionsLoadingInProgress = useSelector(
    (state: RootState) => state.payment.isSubscriptionsLoadingInProgress,
  )
  const [selectedTab, setSelectedTab] = useState<string>('month')
  const filteredSubscriptons = subscriptions
    .filter((subscription: any) => subscription.interval === selectedTab)
    .sort((a: any, b: any) => a.unit_amount - b.unit_amount)

  const handleMakePayment = (data: any) => {
    const { priceId, planId, planName, interval } = data
    dispatch(setIsPaymentProcessing(true))
    dispatch(
      createSubscriptionAsync({
        organizationId: organization?.id,
        priceId,
        productId: planId,
        productName: planName,
      }),
    )
  }

  return (
    <>
      {!isSubscriptionsLoadingInProgress ? (
        <Box>
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: '40px',
            }}
          >
            Plans
          </Typography>
          <Box
            sx={{
              justifyItems: 'center',
            }}
          >
            <Box
              sx={{
                justifyItems: 'center',
              }}
            >
              <Button
                value={'month'}
                sx={{
                  textTransform: 'none',
                  border: '1px solid #1705E5',
                  background: selectedTab === 'month' ? '#1705E5' : '',
                  color: selectedTab === 'month' ? '#F5F5F5' : '#1705E5',
                }}
                onClick={(e: any) => setSelectedTab('month')}
              >
                {'Monthly'}
              </Button>
              <Button
                value={'year'}
                sx={{
                  textTransform: 'none',
                  border: '1px solid #1705E5',
                  background: selectedTab === 'year' ? '#1705E5' : '',
                  color: selectedTab === 'year' ? '#F5F5F5' : '#1705E5',
                }}
                onClick={(e: any) => setSelectedTab('year')}
              >
                {'Yearly'}
              </Button>
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              gap: 1,
            }}
          >
            {filteredSubscriptons.map((subscription: any) => {
              const features = subscription.product.marketing_features.map(
                (feature: any) => feature.name,
              )
              return (
                <SubscriptionsPlan
                  priceId={subscription?.id}
                  planId={subscription.product.id}
                  planName={subscription.product.name}
                  planType={subscription.nickname}
                  interval={subscription.interval}
                  price={'$ ' + subscription?.unit_amount / 100}
                  period={'Per ' + subscription?.recurring.interval}
                  planTypeBgColor={
                    subscription.nickname === 'Full Suite'
                      ? '#CDF765'
                      : '#E5F0FF'
                  }
                  features={features}
                  isCurrentPlan={
                    subscription.id === currentSubscriptionPlan?.price_id
                  }
                  handleMakePayment={handleMakePayment}
                />
              )
            })}
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  )
}

export default Subscriptions
